/* global Glider */

function h (tag, attrs, children) {
	const el = document.createElement(tag)
	if (attrs) {
		if (attrs.style) {
			Object.keys(attrs.style).forEach(prop => {
				el.style[prop] = attrs.style[prop]
			})
		}
		Object.keys(attrs).forEach(attr => {
			if (attr === 'style') return
			el.setAttribute(attr, attrs[attr])
		})
	}
	children && children.forEach(child => {
		if (typeof child === 'string') {
			el.appendChild(document.createTextNode(child))
		} else if (child instanceof Node || child instanceof DocumentFragment) {
			el.appendChild(child)
		} else {
			console.log(child)
			throw new Error('Invalid type')
		}
	})
	return el
}

class ProductImageView {
	/**
	 *
	 * @param {Element} replacer
	 */
	constructor (replacer) {
		this.replacer = replacer
		this.wrap = null
		this.largeImg = null
		this.glideEl = null
		this.images = []
		this.parseOptions()

		if (this.images.length < 2) return
		this.createDOM()
		this.initGlider()
		this.initEvents()
	}

	parseOptions () {
		const images = JSON.parse(this.replacer.getAttribute('data-images'))
		if (images.length < 1) return
		this.images = images
	}

	createDOM () {
		const { replacer } = this
		const firstImage = this.images[0]

		this.wrap = h('div', {
			class: 'glider-contain'
		}, [
			h('figure', {
				class: 'product-image-large'
			}, [
				this.largeImg = h('img', {
					class: 'image-responsive',
					alt: firstImage.caption || '',
					src: this.resolveImageSrc(firstImage.image)
				})
			]),
			this.glideEl = h('div', {
				class: 'glider product-thumb-list'
			}, this.images.map((image, index) => {
				return h('div', {
					'data-index': index,
					class: 'product-thumb'
				}, [
					h('img', {
						alt: image.caption || '',
						src: this.resolveImageSrc(image.image)
					})
				])
			}))
		])

		replacer.parentNode.appendChild(this.wrap)
		replacer.parentNode.removeChild(replacer)
	}

	initGlider () {
		this.glider = new Glider(this.glideEl, {
			slidesToShow: 6.33,
			draggable: true
		})
	}

	initEvents () {
		this.glideEl.addEventListener('click', (event) => {
			const target = event.target
			const index = parseInt(target.getAttribute('data-index'), 10)
			this.selectImage(index)
		})
		this.glideEl.addEventListener('mouseover', (event) => {
			const target = event.target
			const index = parseInt(target.getAttribute('data-index'), 10)
			if (isNaN(index)) return
			this.selectImage(index)
		})
	}

	selectImage (index) {
		const image = this.images[index]
		if (!image) return

		this.largeImg.src = this.resolveImageSrc(image.image)
	}

	resolveImageSrc (uid) {
		return '/uploads/raw/' + uid
	}
}

const view = new ProductImageView(document.getElementById('product-image-replace'))
console.log(view)
